<template>
  <v-row justify="center">
    <v-dialog v-model="isOpen" max-width="290">
      <v-card>
        <v-card-title class="center-title text-center headline">{{ title }}</v-card-title>
        <v-card-text>{{ description }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeModal">
            {{ cancelText }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="confirmAction">
            {{ confirmText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  name: 'ConfirmationModal',
  data () {
    return {
      isOpen: false,
      params: null
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    confirmText: {
      type: String,
      default: 'Si'
    },
    cancelText: {
      type: String,
      default: 'No'
    }
  },
  methods: {
    openModal (params = null) {
      this.params = params
      this.isOpen = true
    },
    closeModal () {
      this.isOpen = false
    },
    confirmAction () {
      this.closeModal()
      this.$emit('confirmAction', this.params)
    }
  }
}
</script>

<style scoped>
  .center-title{
    display: block;
  }
</style>
